import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "debugLogPage" };
const _hoisted_2 = { class: "actions" };
const _hoisted_3 = {
    key: 0,
    class: "empty"
};
const _hoisted_4 = { class: "meta" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "meta" };
const _hoisted_7 = { class: "status" };
const _hoisted_8 = {
    key: 0,
    class: "label"
};
const _hoisted_9 = { key: 1 };
import { ref, computed, shallowReactive } from 'vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import PeriodToggle from './elements/PeriodToggle.vue';
import SuccessToast from './elements/SuccessToast.vue';
import { debugEntries, clearDebugLog, format } from '@/utils/debugLog';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DebugLogPage',
    setup(__props) {
        const tabs = [{ key: 'console', label: 'Console' }, { key: 'network', label: 'Network' }];
        const tab = ref('console');
        const expanded = shallowReactive(new Set());
        const copiedCount = ref(0);
        // Newest first
        const shown = computed(() => debugEntries.filter(e => e.kind === tab.value).reverse());
        function time(e) {
            return e.time.toLocaleTimeString('en-GB');
        }
        // Strings print as they are, so a log line isn't wrapped in quotes
        function consoleText(e) {
            return e.args.map(a => (typeof a === 'string' ? a : format(a))).join(' ');
        }
        function isOk(e) {
            return typeof e.status === 'number' && e.status < 400;
        }
        function toggle(e) {
            if (expanded.has(e))
                expanded.delete(e);
            else
                expanded.add(e);
        }
        async function copy() {
            const text = debugEntries.map(e => e.kind === 'console'
                ? `${time(e)} [${e.level}] ${consoleText(e)}`
                : `${time(e)} ${e.status} ${e.method} ${e.url} (${e.ms}ms)\nRequest: ${format(e.request)}\nResponse: ${format(e.response)}`).join('\n\n');
            try {
                await navigator.clipboard.writeText(text);
                copiedCount.value = 1;
            }
            catch (err) {
                console.error('Could not copy the debug log', err);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Debug log" }),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(PeriodToggle, {
                        modelValue: tab.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tab).value = $event)),
                        periods: tabs
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(MGButton, {
                            text: "Copy",
                            small: true,
                            outline: true,
                            onClick: copy
                        }),
                        _createVNode(MGButton, {
                            text: "Clear",
                            small: true,
                            outline: true,
                            onClick: _unref(clearDebugLog)
                        }, null, 8, ["onClick"])
                    ]),
                    (!shown.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Nothing logged yet"))
                        : _createCommentVNode("", true),
                    (tab.value === 'console')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(shown.value, (e, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: _normalizeClass(["row", e.level])
                            }, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(time(e)) + " · " + _toDisplayString(e.level), 1),
                                _createElementVNode("pre", null, _toDisplayString(consoleText(e)), 1)
                            ], 2));
                        }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(shown.value, (e, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "row",
                                onClick: ($event) => (toggle(e))
                            }, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(time(e)) + " · " + _toDisplayString(e.ms) + "ms", 1),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["request", { failed: !isOk(e) }])
                                }, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(e.status), 1),
                                    _createTextVNode(" " + _toDisplayString(e.method) + " " + _toDisplayString(e.url), 1)
                                ], 2),
                                (_unref(expanded).has(e))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (e.request !== undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Request"))
                                            : _createCommentVNode("", true),
                                        (e.request !== undefined)
                                            ? (_openBlock(), _createElementBlock("pre", _hoisted_9, _toDisplayString(_unref(format)(e.request)), 1))
                                            : _createCommentVNode("", true),
                                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "Response", -1)),
                                        _createElementVNode("pre", null, _toDisplayString(_unref(format)(e.response)), 1)
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ], 8, _hoisted_5));
                        }), 128))
                ]),
                _createVNode(SuccessToast, {
                    count: copiedCount.value,
                    "onUpdate:count": _cache[1] || (_cache[1] = ($event) => ((copiedCount).value = $event)),
                    message: "Copied to clipboard"
                }, null, 8, ["count"])
            ], 64));
        };
    }
});
